// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__27vNN","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1dqT8","obliqueLine":"membershipbadge_obliqueLine__LPnuD"};